module.exports = __webpack_public_path__ + "img/Property Man.12fbb45c.svg";